// @flow
import { useState, Fragment } from 'react';
import { animated, useSpring } from 'react-spring/web.cjs';
import loadable from '@loadable/component';
import styled from '@emotion/styled';
import CorePanel from '@tablekit/panel';
import { COLORS } from '@tablekit/theme';
import { Z_INDICES } from 'utils/theme';
import Desktop from './Desktop';
import type { NavPropsType } from './types';
import MobileNavToggle from './MobileNavToggle';

const Mobile = loadable(() => import('./Mobile'));

const Panel = styled(CorePanel)`
  z-index: ${Z_INDICES.MOBILE_NAV};
  overflow: auto;
`;

const MobileNavTint = animated(styled.div`
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  visibility: hidden;
  background-color: ${COLORS.GRAY_TRANSLUCENT.L6};
  z-index: ${Z_INDICES.MOBILE_NAV - 1};
`);

const Nav = (props: NavPropsType) => {
  const [showMobileMenu, setShowMobileMenu] = useState(false);
  const defaultIsMobileToggle =
    typeof window !== 'undefined' ? window.isMobileToggleVisible : undefined;
  const [isMobileToggleVisible, internalSetIsMobileToggleVisible] = useState(
    defaultIsMobileToggle || false
  );
  const setIsMobileToggleVisible = (newToggleValue) => {
    window.isMobileToggleVisible = newToggleValue;
    internalSetIsMobileToggleVisible(newToggleValue);
  };

  const tintStyles = useSpring({ visible: showMobileMenu ? 1 : 0 });

  return (
    <Fragment>
      <Desktop
        {...props}
        isMobileToggleVisible={isMobileToggleVisible}
        setIsMobileToggleVisible={setIsMobileToggleVisible}
      />
      <Panel
        position="right"
        width="300px"
        onClickOutside={() => setShowMobileMenu(false)}
        isOpen={showMobileMenu}
      >
        <Mobile {...props} hideMobileMenu={() => setShowMobileMenu(false)} />
      </Panel>
      <MobileNavTint
        style={{
          opacity: tintStyles.visible,
          visibility: tintStyles.visible.interpolate((v) =>
            v === 0 ? 'hidden' : 'visible'
          )
        }}
      />
      <MobileNavToggle
        isVisible={isMobileToggleVisible}
        isOpen={showMobileMenu}
        toggleOpen={() => setShowMobileMenu(!showMobileMenu)}
      />
    </Fragment>
  );
};

export default Nav;
